import { useContext } from "react";
import { UserContext } from "../../../contexts/UserContext";
import { fetchUserData } from "./fetchUserData";
import { loginRequestREMA, loginRequestWiMuleCloud } from "./entraConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { entraConfigs } from "./entraConfig";
import { useFetchCloudUserDetails } from "../../../hooks/Cloud/useFetchCloudUserDetails";

export const useAzureAuth = () => {
  const { setUserDetails } = useContext(UserContext);
  const fetchCloudUserDetails = useFetchCloudUserDetails();

  const checkUserExistsInEntra = async (email) => {
    return null
  };
  const isCloud = import.meta.env.VITE_LOCATION === "cloud";
  

  const loginWithAzure = async (provider) => {
    console.error("#################################");
    console.error("NEW LOGIN CODE SEPT 2026");
    console.error("#################################");

    const msalInstance = new PublicClientApplication(entraConfigs[provider]);   
    
    const request =
      provider === "wioss"
        ? loginRequestWiMuleCloud
        : loginRequestREMA;

    await msalInstance.initialize();
    let accounts = msalInstance.getAllAccounts();
    let response = null;

    if (accounts.length > 0) {
      console.log("Attempting silent login...");
      try {
        response = await msalInstance.acquireTokenSilent({
          scopes: request.scopes,
          account: accounts[0],
        });
        
      } catch (silentError) {
        console.warn(
          "Silent login failed, switching to interactive login:",
          silentError
        );
      }
    }
    console.log("Azure response", response)


    console.log("Azure response", response);

    if (!response) {
      console.log("Prompting user for interactive login...");
      try {
        response = await msalInstance.loginPopup({
          scopes: request.scopes,
          prompt: "select_account",
          redirectUri: entraConfigs[provider].auth.redirectUri,
        });
      } catch (popupError) {
        console.error("Azure login failed:", popupError);
        return null;
      }
    }

    const payload = JSON.parse(atob(response.idToken.split(".")[1]));
    const email = payload.preferred_username || payload.email;

    console.log("Access Token:", response.accessToken);

    const accessPayload = JSON.parse(
      atob(response.accessToken.split(".")[1])
    );

    console.log("Access Token Payload:", accessPayload);
    console.log("Audience:", accessPayload.aud);
    console.log("Scopes:", accessPayload.scp);

    if (!email) {
      console.error("Email not retrieved from Azure token.");
      return null;
    }

    console.log("Azure authenticated email:", email);
        console.log("Requested scopes:", request.scopes);
    console.log("Issued scopes:", response?.scopes);

    // Fetch user data from backend
    try {
          if (isCloud) {
            await fetchCloudUserDetails(response.accessToken);
          } else {
            await fetchUserData(email);
          }
      
      const userDataResponse = await fetchUserData(email);
      const userData = userDataResponse?.data?.userAuth;


      setUserDetails({
        userEmail: userData.email,
        userName: userData.userName,
        userCompany: userData.company,
        userAccessLevel: userData.accessLevel,
        userImage: userData.image?.imageData
          ? `data:image/png;base64,${userData.image.imageData}`
          : null,
        userWiMuleToken: userDataResponse.data.wiMuleToken,
        userWiMuleTokenTimestamp: userDataResponse.data.wiMuleTokenTimestamp,
      });

      return { verifiedEmail: email, userDetails: userData };
    } catch (fetchError) {
      console.error("Failed to fetch user details from backend:", fetchError);
      return null;
    }
  };

  

  return { checkUserExistsInEntra, logoutFromAzure, loginWithAzure };
};

export const logoutFromAzure = async (msalInstance) => {
  if (!msalInstance) return;
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    await msalInstance.logoutPopup({ account: accounts[0] });
  }
};
